import React, { useState, useEffect } from 'react';
import MainApp from './components/MainApp';
import LoginScreen from './components/LoginScreen';

const App: React.FC = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const theme = localStorage.getItem('theme') || 'dark';
        document.documentElement.setAttribute('data-theme', theme);
    }, []);

    useEffect(() => {
        const token = localStorage.getItem('auth_token');
        if (token) {
            // Есть токен — сразу показываем приложение, проверяем в фоне
            setIsAuthenticated(true);
            setLoading(false);
            fetch('/api/auth/verify', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token }),
            }).then(res => {
                if (!res.ok) {
                    localStorage.removeItem('auth_token');
                    setIsAuthenticated(false);
                }
            }).catch(() => {
                // Нет сети — оставляем залогиненным
            });
        } else {
            setIsAuthenticated(false);
            setLoading(false);
        }
    }, []);

    const handleLogin = () => { setIsAuthenticated(true); };
    const handleLogout = () => { setIsAuthenticated(false); };

    if (loading) {
        return (
            <div className="cb-canvas" style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                fontFamily: 'var(--sans)',
            }}>
                <div style={{ position: 'relative', zIndex: 1, color: 'var(--text2)', fontSize: 16 }}>
                    Загрузка...
                </div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <LoginScreen onLogin={handleLogin} />;
    }

    return <MainApp onLogout={handleLogout} />;
};

export default App;
